import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginDto } from '../_interfaces/login.dto';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  accessToken: string = null;
  refreshToken: string = null;

  isLoggedInStream: BehaviorSubject<boolean> = new BehaviorSubject(false);
  permissionsStream: BehaviorSubject<any[]> = new BehaviorSubject([]);
  userStream: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor(private httpClient: HttpClient) {}

  init(): Observable<any> {
    this.accessToken = window.localStorage.getItem('accessToken');
    this.refreshToken = window.localStorage.getItem('refreshToken');

    if (this.accessToken) {
      this.isLoggedInStream.next(true);
    }

    const permissions = window.localStorage.getItem('permissions');
    if (permissions) {
      this.permissionsStream.next(JSON.parse(permissions));
    }

    return of(null);
  }

  login(dto: LoginDto): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.baseApiUrl}/auth/login`, {
        username: dto.username,
        password: dto.password,
      })
      .pipe(
        tap((res) => {
          if (!res.success) {
            return;
          }
          this.accessToken = res.data.accessToken;
          this.refreshToken = res.data.refreshToken;
          window.localStorage.setItem('username', dto.username);
          this.isLoggedInStream.next(true);
          const user = window.localStorage.getItem('username');
          if (user) {
            this.userStream.next(user);
          }
          if (!dto.shouldRemember) {
            return;
          }
          window.localStorage.setItem('accessToken', res.data.accessToken);
          window.localStorage.setItem('refreshToken', res.data.refreshToken);
        })
      );
  }

  refreshTokens(): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.baseApiUrl}/auth/refreshTokens`, {
        refreshToken: this.refreshToken,
      })
      .pipe(
        tap((res) => {
          if (!res.success) {
            return;
          }

          this.accessToken = res.data.accessToken;
          //this.refreshToken = res.data.refreshToken;

          const accessToken = window.localStorage.getItem('accessToken');

          if (!accessToken) {
            return;
          }

          window.localStorage.setItem('accessToken', res.data.accessToken);
          // window.localStorage.setItem('refreshToken', res.data.refreshToken);
        })
      );
  }

  logout(): Observable<any> {
    this.isLoggedInStream.next(false);
    this.userStream.next(null);
    window.localStorage.clear();
    this.accessToken = null;
    this.refreshToken = null;

    return of(null);
  }
}
